var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.91248 51.0579C2.57915 51.8263 0.913849 50.864 0.913849 49.3251V4.24709C0.913849 2.70819 2.57915 1.74584 3.91248 2.51424L43.0224 25.0533C44.3575 25.8227 44.3575 27.7495 43.0224 28.5189L3.91248 51.0579Z","fill":"#FFFCF3"}));
}

PlayButton.defaultProps = {"viewBox":"0 0 47 53","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
